/* tslint:disable */

/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Identifies if the client is a primary contact or not
 * @export
 * @enum {string}
 */
export enum ContactType {
	Unknown = 'unknown',
	Primary = 'primary',
}

export function ContactTypeFromJSON(json: any): ContactType {
	return ContactTypeFromJSONTyped(json, false);
}

export function ContactTypeFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ContactType {
	return json as ContactType;
}

export function ContactTypeToJSON(value?: ContactType | null): any {
	return value as any;
}
